import React from 'react';
import {CartItemDataHook} from '../../CartItem';
import s from '../../CartItem.scss';
import {LineItemModel} from '../../../../../../domain/models/LineItems/LineItem.model';
import {useExperiments, useTranslation} from '@wix/yoshi-flow-editor';
import {getLineItemSubscriptionFrequencyText} from '../../../../../../domain/utils/getLineItemSubscriptionFrequencyText';
import {SkeletonLineWrapper} from '../../../../Skeleton/SkeletonLine/SkeletonLineWrapper';
import {SkeletonRow} from '../../../../Skeleton/SkeletonRow/SkeletonRow';
import {Skeleton} from '../../../../Skeleton/Skeleton';
import {SPECS} from '../../../../../../domain/specs';

export const TotalPrice = ({
  lineItem,
  shouldShowCrossedOutPriceOnLineItemLevel,
  isItemLoading,
}: {
  lineItem: LineItemModel;
  shouldShowCrossedOutPriceOnLineItemLevel: boolean;
  isItemLoading: boolean;
}) => {
  const {experiments} = useExperiments();
  const showCrossedOutPriceOnLineItemLevel = experiments.enabled(SPECS.ShowCrossedOutPriceOnLineItemLevel);
  const totalPriceClassName = experiments.enabled(SPECS.FixTotalPriceCSSSideCart)
    ? s.totalPrice
    : /* istanbul ignore next */ s.totalPriceOld;
  const shouldDisplayFrequency =
    lineItem.attributes.subscriptionInfo &&
    lineItem.attributes.subscriptionInfo.subscriptionSettings.billingCycles !== 1;

  const {t} = useTranslation();

  if (isItemLoading) {
    return (
      <Skeleton dataHook={CartItemDataHook.totalPriceSkeleton} className={totalPriceClassName}>
        <SkeletonRow>
          <SkeletonLineWrapper size="small" />
        </SkeletonRow>
      </Skeleton>
    );
  }

  return (
    <div
      className={totalPriceClassName}
      data-hook={CartItemDataHook.TotalPrice}
      data-wix-item-total-price={CartItemDataHook.TotalPrice}>
      <div className={showCrossedOutPriceOnLineItemLevel ? s.priceRow : s.priceRowOld}>
        {(shouldShowCrossedOutPriceOnLineItemLevel || showCrossedOutPriceOnLineItemLevel) &&
          lineItem.pricing.breakdown.comparePrice?.formattedConvertedAmount && (
            <div
              data-hook={CartItemDataHook.ComparePriceOnLineItem}
              className={s.comparePrice}
              data-wix-line-item-crossed-out-price={CartItemDataHook.ComparePriceOnLineItem}>
              {lineItem.pricing.breakdown.comparePriceByQuantity.formattedConvertedAmount}
            </div>
          )}
        <div className={s.totalPriceText}>{lineItem.pricing.totalPrice.formattedConvertedAmount}</div>
      </div>

      {shouldDisplayFrequency && (
        <div className={s.subscriptionFrequency} data-hook={CartItemDataHook.SubscriptionFrequency}>
          {getLineItemSubscriptionFrequencyText(t, lineItem.attributes.subscriptionInfo.subscriptionSettings)}
        </div>
      )}
    </div>
  );
};
